// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProseMirror {
  p {
    line-height: 1.625; /* leading-relaxed */
    margin-top: 0.75rem; /* my-3 */
    margin-bottom: 0.75rem;
  }

  p:first-of-type {
    margin-top: 0; /* first:mt-0 */
  }

  p:last-of-type {
    margin-bottom: 0; /* last:mb-0 */
  }

  & > p {
    margin-top: 1.5rem; /* my-6 */
    margin-bottom: 1.5rem;
  }

  h1 {
    font-size: 1.875rem; /* text-3xl */
  }

  h2 {
    font-size: 1.5rem; /* text-2xl */
  }

  h3 {
    font-size: 1.25rem; /* text-xl */
  }

  h4 {
    font-size: 1.125rem; /* text-lg */
  }

  h5 {
    font-size: 1rem; /* text-base */
  }

  h6 {
    font-size: 0.875rem; /* text-sm */
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: bold; /* font-bold */
    margin-top: 0; /* first:mt-0 */
    margin-bottom: 0; /* last:mb-0 */
  }

  h1,
  h2,
  h3 {
    margin-top: 0.5rem; /* mt-12 */
  }

  h4,
  h5,
  h6 {
    margin-top: 0.2rem; /* mt-8 */
  }

  a.link {
    color: #3b82f6; /* text-blue-500 */
    font-weight: 800; /* font-extrabold */
  }

  a.link:visited {
    color: #60a5fa; /* dark:text-blue-400 */
  }

  mark {
    background-color: #f87171; /* bg-red-500 */
    border-radius: 0.125rem; /* rounded-sm */
    text-decoration-skip: ink; /* decoration-clone */
    color: inherit; /* text-inherit */
    padding: 0.25rem 0; /* py-1 px-0 */
  }

  mark.dark {
    background-color: #fb7185; /* dark:bg-red-400 */
  }

  & img {
    height: auto; /* h-auto */
    width: 100%; /* w-full */
    max-width: 100%; /* max-w-full */
  }

  [data-type="horizontalRule"] {
    margin-top: 2rem; /* my-8 */
    margin-bottom: 2rem;
    padding-top: 1rem; /* py-4 */
    padding-bottom: 1rem;
    transition: all 0.1s ease-in-out; /* transition-all duration-100 ease-in-out */
    cursor: pointer;
  }

  [data-type="horizontalRule"].ProseMirror-selectednode {
    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */
  }

  [data-type="horizontalRule"].ProseMirror-selectednode hr {
    border-top: 1px solid rgba(0, 0, 0, 0.3); /* border-t-black/30 */
  }

  [data-type="horizontalRule"]:hover:not(.ProseMirror-selectednode) {
    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */
  }

  hr {
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.2); /* border-t border-black/20 */
    background-color: rgba(0, 0, 0, 0.8); /* bg-black/80 */
  }

  [data-type="emoji"] {
    display: inline-block;
  }

  [data-type="emoji"] img {
    width: 1em;
    height: 1em;
    object-fit: cover;
    display: block;
  }
}

.ProseMirror {
  .tableWrapper {
    margin-top: 3rem; /* my-12 */
    margin-bottom: 3rem;
  }

  table {
    border-collapse: collapse;
    border: 1px solid rgba(0, 0, 0, 0.1); /* border-black/10 */
    border-radius: 0.375rem; /* rounded */
    box-sizing: border-box; /* box-border */
    width: 100%; /* w-full */
  }

  td,
  th {
    border: 1px solid rgba(0, 0, 0, 0.1); /* border-black/10 */
    min-width: 100px; /* min-w-[100px] */
    padding: 0.5rem; /* p-2 */
    position: relative;
    text-align: left; /* text-left */
    vertical-align: top; /* align-top */
  }

  td:first-of-type:not(a) {
    margin-top: 0; /* mt-0 */
  }

  td p {
    margin: 0; /* m-0 */
  }

  td p + p {
    margin-top: 0.75rem; /* mt-3 */
  }

  th {
    font-weight: bold; /* font-bold */
  }

  .column-resize-handle {
    bottom: -2px; /* -bottom-[2px] */
    display: flex;
    pointer-events: none; /* pointer-events-none */
    position: absolute;
    right: -1px; /* -right-1 */
    top: 0; /* top-0 */
    width: 0.5rem; /* w-2 */
  }

  .column-resize-handle::before {
    background-color: rgba(0, 0, 0, 0.2); /* bg-black/20 */
    height: 100%; /* h-full */
    width: 1px; /* w-[1px] */
    margin-left: 0.5rem; /* ml-2 */
    content: "";
  }

  .selectedCell {
    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */
    border-color: rgba(0, 0, 0, 0.2); /* border-black/20 */
    border-style: double; /* border-double */
  }

  .grip-column,
  .grip-row {
    align-items: center; /* items-center */
    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */
    cursor: pointer; /* cursor-pointer */
    display: flex;
    justify-content: center; /* justify-center */
    position: absolute;
    z-index: 10; /* z-10 */
  }

  .grip-column {
    width: calc(100% + 1px); /* w-[calc(100%+1px)] */
    border-left: 1px solid rgba(0, 0, 0, 0.2); /* border-l border-black/20 */
    height: 0.75rem; /* h-3 */
    left: 0; /* left-0 */
    margin-left: -1px; /* -ml-[1px] */
    top: -0.75rem; /* -top-3 */
  }

  .grip-column:hover,
  .grip-column.selected {
    &::before {
      content: "";
      width: 0.625rem; /* w-2.5 */
    }
  }

  .grip-column:hover {
    background-color: rgba(0, 0, 0, 0.1); /* bg-black/10 */
  }

  .grip-column:hover::before {
    border-bottom: 2px solid rgba(0, 0, 0, 0.6); /* border-b-2 border-dotted border-black/60 */
  }

  .grip-column.first {
    border-color: transparent; /* border-transparent */
    border-radius: 0.125rem 0 0 0; /* rounded-tl-sm */
  }

  .grip-column.last {
    border-radius: 0 0.125rem 0 0; /* rounded-tr-sm */
  }

  .grip-column.selected {
    background-color: rgba(0, 0, 0, 0.3); /* bg-black/30 */
    border-color: rgba(0, 0, 0, 0.3); /* border-black/30 */
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15); /* shadow-sm */
  }

  .grip-column.selected::before {
    border-bottom: 2px solid dotted; /* border-b-2 border-dotted */
  }

  .grip-row {
    height: calc(100% + 1px); /* h-[calc(100%+1px)] */
    border-top: 1px solid rgba(0, 0, 0, 0.2); /* border-t border-black/20 */
    left: -0.75rem; /* -left-3 */
    width: 0.75rem; /* w-3 */
    top: 0; /* top-0 */
    margin-top: -1px; /* -mt-[1px] */
  }

  .grip-row:hover,
  .grip-row.selected {
    &::before {
      height: 0.625rem; /* h-2.5 */
      content: "";
    }
  }

  .grip-row:hover {
    background-color: rgba(0, 0, 0, 0.1); /* bg-black/10 */
  }

  .grip-row:hover::before {
    border-left: 2px solid dotted rgba(0, 0, 0, 0.6); /* border-l-2 border-dotted border-black/60 */
  }

  .grip-row.first {
    border-color: transparent; /* border-transparent */
    border-radius: 0.125rem 0 0 0; /* rounded-tl-sm */
  }

  .grip-row.last {
    border-radius: 0 0.125rem 0 0; /* rounded-bl-sm */
  }

  .grip-row.selected {
    background-color: rgba(0, 0, 0, 0.3); /* bg-black/30 */
    border-color: rgba(0, 0, 0, 0.3); /* border-black/30 */
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15); /* shadow-sm */
  }

  .grip-row.selected::before {
    border-left: 2px solid dotted; /* border-l-2 border-dotted */
  }
}

.ProseMirror ol {
  list-style-type: decimal; /* list-decimal */
}

.ProseMirror ul {
  list-style-type: disc; /* list-disc */
}

.ProseMirror ul,
.ProseMirror ol {
  padding-top: 0; /* py-0 */
  padding-bottom: 0; /* py-0 */
  padding-left: 2rem; /* px-8 */
  padding-right: 2rem; /* px-8 */
  margin-top: 1.5rem; /* my-6 */
  margin-bottom: 1.5rem; /* my-6 */
}

.ProseMirror ul:first-child,
.ProseMirror ol:first-child {
  margin-top: 0; /* first:mt-0 */
}

.ProseMirror ul:last-child,
.ProseMirror ol:last-child {
  margin-bottom: 0; /* last:mb-0 */
}

.ProseMirror ul ul,
.ProseMirror ul ol,
.ProseMirror ul li,
.ProseMirror ol ul,
.ProseMirror ol ol,
.ProseMirror ol li {
  margin-top: 0.25rem; /* my-1 */
  margin-bottom: 0.25rem; /* my-1 */
}

.ProseMirror ul p,
.ProseMirror ol p {
  margin-top: 0; /* mt-0 */
  margin-bottom: 0.25rem; /* mb-1 */
}

.ProseMirror > ul,
.ProseMirror > ol {
  margin-top: 2rem; /* my-8 */
  margin-bottom: 2rem; /* my-8 */
}

.ProseMirror > ul:first-child,
.ProseMirror > ol:first-child {
  margin-top: 0; /* first:mt-0 */
}

.ProseMirror > ul:last-child,
.ProseMirror > ol:last-child {
  margin-bottom: 0; /* last:mb-0 */
}

.ProseMirror ul[data-type="taskList"] {
  list-style-type: none; /* list-none */
  padding: 0; /* p-0 */
}

.ProseMirror ul[data-type="taskList"] p {
  margin: 0; /* m-0 */
}

.ProseMirror ul[data-type="taskList"] li {
  display: flex; /* flex */
}

.ProseMirror ul[data-type="taskList"] li > label {
  flex-grow: 0; /* grow-0 */
  flex-shrink: 0; /* shrink-0 */
  flex-basis: auto; /* flex-auto */
  margin-top: 0.25rem; /* mt-1 */
  margin-right: 0.5rem; /* mr-2 */
  user-select: none; /* select-none */
}

.ProseMirror ul[data-type="taskList"] li > div {
  flex-basis: auto; /* flex-auto */
}

.ProseMirror ul[data-type="taskList"] li[data-checked="true"] {
  text-decoration: line-through; /* line-through */
}

.ProseMirror code {
  caret-color: white; /* caret-white */
  color: white; /* text-white */
  background-color: #1a1a1a; /* bg-neutral-900 */
  border-radius: 0.125rem; /* rounded-sm */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* shadow-lg */
  font-family: monospace; /* font-mono */
}

.ProseMirror code::selection {
  background-color: rgba(255, 255, 255, 0.3); /* bg-white/30 */
}

.ProseMirror pre {
  caret-color: white; /* caret-white */
  background-color: #3f3f46; /* bg-neutral-700 */
  color: white; /* text-white */
  border-radius: 0.25rem; /* rounded */
  margin-top: 3rem; /* my-12 */
  margin-bottom: 3rem; /* my-12 */
  padding: 1rem; /* p-4 */
  border: 1px solid black; /* border-black */
}

.ProseMirror pre.dark {
  background-color: #1a1a1a; /* dark:bg-neutral-900 */
  border-color: #1f2937; /* dark:border-neutral-800 */
}

.ProseMirror pre *::selection {
  background-color: rgba(255, 255, 255, 0.2); /* bg-white/20 */
}

.ProseMirror pre code {
  background-color: inherit; /* bg-inherit */
  color: inherit; /* text-inherit */
  padding: 0; /* p-0 */
  box-shadow: none; /* shadow-none */
}

.ProseMirror pre .hljs-comment,
.ProseMirror pre .hljs-quote {
  color: #9ca3af; /* text-neutral-400 */
}

.ProseMirror pre .hljs-variable,
.ProseMirror pre .hljs-template-variable,
.ProseMirror pre .hljs-attribute,
.ProseMirror pre .hljs-tag,
.ProseMirror pre .hljs-name,
.ProseMirror pre .hljs-regexp,
.ProseMirror pre .hljs-link,
.ProseMirror pre .hljs-selector-id,
.ProseMirror pre .hljs-selector-class {
  color: #f87171; /* text-red-300 */
}

.ProseMirror pre .hljs-number,
.ProseMirror pre .hljs-meta,
.ProseMirror pre .hljs-built_in,
.ProseMirror pre .hljs-builtin-name,
.ProseMirror pre .hljs-literal,
.ProseMirror pre .hljs-type,
.ProseMirror pre .hljs-params {
  color: #fb923c; /* text-orange-300 */
}

.ProseMirror pre .hljs-string,
.ProseMirror pre .hljs-symbol,
.ProseMirror pre .hljs-bullet {
  color: #4ade80; /* text-lime-300 */
}

.ProseMirror pre .hljs-title,
.ProseMirror pre .hljs-section {
  color: #facc15; /* text-yellow-300 */
}

.ProseMirror pre .hljs-keyword,
.ProseMirror pre .hljs-selector-tag {
  color: #2dd4bf; /* text-teal-300 */
}

.ProseMirror pre .hljs-emphasis {
  font-style: italic;
}

.ProseMirror pre .hljs-strong {
  font-weight: 700; /* font-bold */
}

.ProseMirror {
  /* Image Block */
  figure[data-type="imageBlock"] {
    margin: 0;
  }

  figure[data-type="imageBlock"] img {
    border-radius: 0.25rem; /* Rounded */
    display: block; /* Block */
    width: 100%; /* W-full */
  }

  /* Block Quote */
  figure[data-type="blockquoteFigure"] {
    margin-top: 3.5rem; /* my-14 */
    margin-bottom: 3.5rem; /* my-14 */
    color: #000000; /* Text-black */
  }

  figure[data-type="blockquoteFigure"].dark {
    color: #ffffff; /* Dark:text-white */
  }

  & > blockquote,
  [data-type="blockquoteFigure"] blockquote {
    margin: 0; /* M-0 */
  }

  [data-type="blockquoteFigure"] blockquote > *:first-child {
    margin-top: 0; /* First:mt-0 */
  }

  [data-type="blockquoteFigure"] blockquote > *:last-child {
    margin-bottom: 0; /* Last:mb-0 */
  }

  /* Columns */
  [data-type="columns"] {
    display: grid; /* Grid */
    gap: 1rem; /* Gap-4 */
    margin-top: 3.5rem; /* Mt-14 */
    margin-bottom: 3rem; /* Mb-12 */
  }

  [data-type="columns"].layout-sidebar-left {
    grid-template-columns: 40fr 60fr;
  }

  [data-type="columns"].layout-sidebar-right {
    grid-template-columns: 60fr 40fr;
  }

  [data-type="columns"].layout-two-column {
    grid-template-columns: 1fr 1fr;
  }

  [data-type="column"] {
    overflow: auto; /* Overflow-auto */
  }

  /* Details */
  [data-type="details"] {
    display: flex; /* Flex */
    gap: 0.25rem; /* Gap-1 */
    margin-top: 1.5rem; /* My-6 */
    margin-bottom: 1.5rem; /* My-6 */
    margin-left: auto; /* Mx-auto */
    margin-right: auto; /* Mx-auto */
    padding: 0.5rem; /* P-2 */
    border: 1px solid #d1d5db; /* Border-gray-300 */
    border-radius: 0.25rem; /* Rounded */
  }

  [data-type="details"] summary {
    font-weight: bold; /* Font-bold */
    display: block; /* Block */
  }

  [data-type="details"] > button {
    background-color: transparent; /* Bg-transparent */
    border: none; /* Border-none */
    cursor: pointer; /* Cursor-pointer */
    display: flex; /* Flex */
    align-items: center; /* Items-center */
    justify-content: center; /* Justify-center */
    border-radius: 0.25rem; /* Rounded */
    font-size: 0.75rem; /* Text-xs */
    height: 1.25rem; /* H-5 */
    width: 1.25rem; /* W-5 */
  }

  [data-type="details"] > button:hover {
    background-color: #d1d5db; /* Bg-gray-300 */
  }

  [data-type="details"].dark > button:hover {
    background-color: #1f2937; /* Dark:bg-gray-800 */
  }

  [data-type="details"] > button::before {
    content: "\\25B6"; /* Triangle icon */
  }

  [data-type="details"].is-open > button::before {
    transform: rotate(90deg); /* Rotate-90 */
  }

  [data-type="details"] > div {
    display: flex; /* Flex */
    flex-direction: column; /* Flex-col */
    gap: 1rem; /* Gap-4 */
    width: 100%; /* W-full */
  }

  [data-type="details"] > div > [data-type="detailsContent"] > :last-child {
    margin-bottom: 0.5rem; /* Mb-2 */
  }

  [data-type="details"] [data-type="details"] {
    margin-top: 0.5rem; /* My-2 */
    margin-bottom: 0.5rem; /* My-2 */
    margin-left: 0; /* Mx-0 */
    margin-right: 0; /* Mx-0 */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Notice/NoticePopup/style.css"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAkB,EAAE,oBAAoB;IACxC,mBAAmB,EAAE,SAAS;IAC9B,sBAAsB;EACxB;;EAEA;IACE,aAAa,EAAE,eAAe;EAChC;;EAEA;IACE,gBAAgB,EAAE,cAAc;EAClC;;EAEA;IACE,kBAAkB,EAAE,SAAS;IAC7B,qBAAqB;EACvB;;EAEA;IACE,mBAAmB,EAAE,aAAa;EACpC;;EAEA;IACE,iBAAiB,EAAE,aAAa;EAClC;;EAEA;IACE,kBAAkB,EAAE,YAAY;EAClC;;EAEA;IACE,mBAAmB,EAAE,YAAY;EACnC;;EAEA;IACE,eAAe,EAAE,cAAc;EACjC;;EAEA;IACE,mBAAmB,EAAE,YAAY;EACnC;;EAEA;;;;;;IAME,iBAAiB,EAAE,cAAc;IACjC,aAAa,EAAE,eAAe;IAC9B,gBAAgB,EAAE,cAAc;EAClC;;EAEA;;;IAGE,kBAAkB,EAAE,UAAU;EAChC;;EAEA;;;IAGE,kBAAkB,EAAE,SAAS;EAC/B;;EAEA;IACE,cAAc,EAAE,kBAAkB;IAClC,gBAAgB,EAAE,mBAAmB;EACvC;;EAEA;IACE,cAAc,EAAE,uBAAuB;EACzC;;EAEA;IACE,yBAAyB,EAAE,eAAe;IAC1C,uBAAuB,EAAE,eAAe;IACxC,yBAAyB,EAAE,qBAAqB;IAChD,cAAc,EAAE,iBAAiB;IACjC,kBAAkB,EAAE,cAAc;EACpC;;EAEA;IACE,yBAAyB,EAAE,oBAAoB;EACjD;;EAEA;IACE,YAAY,EAAE,WAAW;IACzB,WAAW,EAAE,WAAW;IACxB,eAAe,EAAE,eAAe;EAClC;;EAEA;IACE,gBAAgB,EAAE,SAAS;IAC3B,mBAAmB;IACnB,iBAAiB,EAAE,SAAS;IAC5B,oBAAoB;IACpB,gCAAgC,EAAE,4CAA4C;IAC9E,eAAe;EACjB;;EAEA;IACE,qCAAqC,EAAE,eAAe;EACxD;;EAEA;IACE,wCAAwC,EAAE,sBAAsB;EAClE;;EAEA;IACE,qCAAqC,EAAE,eAAe;EACxD;;EAEA;IACE,SAAS;IACT,wCAAwC,EAAE,6BAA6B;IACvE,oCAAoC,EAAE,gBAAgB;EACxD;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB,EAAE,UAAU;IAC5B,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,oCAAoC,EAAE,oBAAoB;IAC1D,uBAAuB,EAAE,YAAY;IACrC,sBAAsB,EAAE,eAAe;IACvC,WAAW,EAAE,WAAW;EAC1B;;EAEA;;IAEE,oCAAoC,EAAE,oBAAoB;IAC1D,gBAAgB,EAAE,kBAAkB;IACpC,eAAe,EAAE,QAAQ;IACzB,kBAAkB;IAClB,gBAAgB,EAAE,cAAc;IAChC,mBAAmB,EAAE,cAAc;EACrC;;EAEA;IACE,aAAa,EAAE,SAAS;EAC1B;;EAEA;IACE,SAAS,EAAE,QAAQ;EACrB;;EAEA;IACE,mBAAmB,EAAE,SAAS;EAChC;;EAEA;IACE,iBAAiB,EAAE,cAAc;EACnC;;EAEA;IACE,YAAY,EAAE,kBAAkB;IAChC,aAAa;IACb,oBAAoB,EAAE,wBAAwB;IAC9C,kBAAkB;IAClB,WAAW,EAAE,aAAa;IAC1B,MAAM,EAAE,UAAU;IAClB,aAAa,EAAE,QAAQ;EACzB;;EAEA;IACE,oCAAoC,EAAE,gBAAgB;IACtD,YAAY,EAAE,WAAW;IACzB,UAAU,EAAE,YAAY;IACxB,mBAAmB,EAAE,SAAS;IAC9B,WAAW;EACb;;EAEA;IACE,qCAAqC,EAAE,eAAe;IACtD,gCAAgC,EAAE,oBAAoB;IACtD,oBAAoB,EAAE,kBAAkB;EAC1C;;EAEA;;IAEE,mBAAmB,EAAE,iBAAiB;IACtC,qCAAqC,EAAE,eAAe;IACtD,eAAe,EAAE,mBAAmB;IACpC,aAAa;IACb,uBAAuB,EAAE,mBAAmB;IAC5C,kBAAkB;IAClB,WAAW,EAAE,SAAS;EACxB;;EAEA;IACE,uBAAuB,EAAE,uBAAuB;IAChD,yCAAyC,EAAE,6BAA6B;IACxE,eAAe,EAAE,QAAQ;IACzB,OAAO,EAAE,WAAW;IACpB,iBAAiB,EAAE,cAAc;IACjC,aAAa,EAAE,WAAW;EAC5B;;EAEA;;IAEE;MACE,WAAW;MACX,eAAe,EAAE,UAAU;IAC7B;EACF;;EAEA;IACE,oCAAoC,EAAE,gBAAgB;EACxD;;EAEA;IACE,2CAA2C,EAAE,6CAA6C;EAC5F;;EAEA;IACE,yBAAyB,EAAE,uBAAuB;IAClD,6BAA6B,EAAE,kBAAkB;EACnD;;EAEA;IACE,6BAA6B,EAAE,kBAAkB;EACnD;;EAEA;IACE,oCAAoC,EAAE,gBAAgB;IACtD,gCAAgC,EAAE,oBAAoB;IACtD,yCAAyC,EAAE,cAAc;EAC3D;;EAEA;IACE,+BAA+B,EAAE,6BAA6B;EAChE;;EAEA;IACE,wBAAwB,EAAE,uBAAuB;IACjD,wCAAwC,EAAE,6BAA6B;IACvE,cAAc,EAAE,YAAY;IAC5B,cAAc,EAAE,QAAQ;IACxB,MAAM,EAAE,UAAU;IAClB,gBAAgB,EAAE,cAAc;EAClC;;EAEA;;IAEE;MACE,gBAAgB,EAAE,UAAU;MAC5B,WAAW;IACb;EACF;;EAEA;IACE,oCAAoC,EAAE,gBAAgB;EACxD;;EAEA;IACE,gDAAgD,EAAE,6CAA6C;EACjG;;EAEA;IACE,yBAAyB,EAAE,uBAAuB;IAClD,6BAA6B,EAAE,kBAAkB;EACnD;;EAEA;IACE,6BAA6B,EAAE,kBAAkB;EACnD;;EAEA;IACE,oCAAoC,EAAE,gBAAgB;IACtD,gCAAgC,EAAE,oBAAoB;IACtD,yCAAyC,EAAE,cAAc;EAC3D;;EAEA;IACE,6BAA6B,EAAE,6BAA6B;EAC9D;AACF;;AAEA;EACE,wBAAwB,EAAE,iBAAiB;AAC7C;;AAEA;EACE,qBAAqB,EAAE,cAAc;AACvC;;AAEA;;EAEE,cAAc,EAAE,SAAS;EACzB,iBAAiB,EAAE,SAAS;EAC5B,kBAAkB,EAAE,SAAS;EAC7B,mBAAmB,EAAE,SAAS;EAC9B,kBAAkB,EAAE,SAAS;EAC7B,qBAAqB,EAAE,SAAS;AAClC;;AAEA;;EAEE,aAAa,EAAE,eAAe;AAChC;;AAEA;;EAEE,gBAAgB,EAAE,cAAc;AAClC;;AAEA;;;;;;EAME,mBAAmB,EAAE,SAAS;EAC9B,sBAAsB,EAAE,SAAS;AACnC;;AAEA;;EAEE,aAAa,EAAE,SAAS;EACxB,sBAAsB,EAAE,SAAS;AACnC;;AAEA;;EAEE,gBAAgB,EAAE,SAAS;EAC3B,mBAAmB,EAAE,SAAS;AAChC;;AAEA;;EAEE,aAAa,EAAE,eAAe;AAChC;;AAEA;;EAEE,gBAAgB,EAAE,cAAc;AAClC;;AAEA;EACE,qBAAqB,EAAE,cAAc;EACrC,UAAU,EAAE,QAAQ;AACtB;;AAEA;EACE,SAAS,EAAE,QAAQ;AACrB;;AAEA;EACE,aAAa,EAAE,SAAS;AAC1B;;AAEA;EACE,YAAY,EAAE,WAAW;EACzB,cAAc,EAAE,aAAa;EAC7B,gBAAgB,EAAE,cAAc;EAChC,mBAAmB,EAAE,SAAS;EAC9B,oBAAoB,EAAE,SAAS;EAC/B,iBAAiB,EAAE,gBAAgB;AACrC;;AAEA;EACE,gBAAgB,EAAE,cAAc;AAClC;;AAEA;EACE,6BAA6B,EAAE,iBAAiB;AAClD;;AAEA;EACE,kBAAkB,EAAE,gBAAgB;EACpC,YAAY,EAAE,eAAe;EAC7B,yBAAyB,EAAE,mBAAmB;EAC9C,uBAAuB,EAAE,eAAe;EACxC,0CAA0C,EAAE,cAAc;EAC1D,sBAAsB,EAAE,cAAc;AACxC;;AAEA;EACE,0CAA0C,EAAE,gBAAgB;AAC9D;;AAEA;EACE,kBAAkB,EAAE,gBAAgB;EACpC,yBAAyB,EAAE,mBAAmB;EAC9C,YAAY,EAAE,eAAe;EAC7B,sBAAsB,EAAE,YAAY;EACpC,gBAAgB,EAAE,UAAU;EAC5B,mBAAmB,EAAE,UAAU;EAC/B,aAAa,EAAE,QAAQ;EACvB,uBAAuB,EAAE,iBAAiB;AAC5C;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;EACnD,qBAAqB,EAAE,4BAA4B;AACrD;;AAEA;EACE,0CAA0C,EAAE,gBAAgB;AAC9D;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,cAAc,EAAE,iBAAiB;EACjC,UAAU,EAAE,QAAQ;EACpB,gBAAgB,EAAE,gBAAgB;AACpC;;AAEA;;EAEE,cAAc,EAAE,qBAAqB;AACvC;;AAEA;;;;;;;;;EASE,cAAc,EAAE,iBAAiB;AACnC;;AAEA;;;;;;;EAOE,cAAc,EAAE,oBAAoB;AACtC;;AAEA;;;EAGE,cAAc,EAAE,kBAAkB;AACpC;;AAEA;;EAEE,cAAc,EAAE,oBAAoB;AACtC;;AAEA;;EAEE,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB,EAAE,cAAc;AAClC;;AAEA;EACE,gBAAgB;EAChB;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB,EAAE,YAAY;IACpC,cAAc,EAAE,UAAU;IAC1B,WAAW,EAAE,WAAW;EAC1B;;EAEA,gBAAgB;EAChB;IACE,kBAAkB,EAAE,UAAU;IAC9B,qBAAqB,EAAE,UAAU;IACjC,cAAc,EAAE,eAAe;EACjC;;EAEA;IACE,cAAc,EAAE,oBAAoB;EACtC;;EAEA;;IAEE,SAAS,EAAE,QAAQ;EACrB;;EAEA;IACE,aAAa,EAAE,eAAe;EAChC;;EAEA;IACE,gBAAgB,EAAE,cAAc;EAClC;;EAEA,YAAY;EACZ;IACE,aAAa,EAAE,SAAS;IACxB,SAAS,EAAE,UAAU;IACrB,kBAAkB,EAAE,UAAU;IAC9B,mBAAmB,EAAE,UAAU;EACjC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,cAAc,EAAE,kBAAkB;EACpC;;EAEA,YAAY;EACZ;IACE,aAAa,EAAE,SAAS;IACxB,YAAY,EAAE,UAAU;IACxB,kBAAkB,EAAE,SAAS;IAC7B,qBAAqB,EAAE,SAAS;IAChC,iBAAiB,EAAE,YAAY;IAC/B,kBAAkB,EAAE,YAAY;IAChC,eAAe,EAAE,QAAQ;IACzB,yBAAyB,EAAE,oBAAoB;IAC/C,sBAAsB,EAAE,YAAY;EACtC;;EAEA;IACE,iBAAiB,EAAE,cAAc;IACjC,cAAc,EAAE,UAAU;EAC5B;;EAEA;IACE,6BAA6B,EAAE,mBAAmB;IAClD,YAAY,EAAE,gBAAgB;IAC9B,eAAe,EAAE,mBAAmB;IACpC,aAAa,EAAE,SAAS;IACxB,mBAAmB,EAAE,iBAAiB;IACtC,uBAAuB,EAAE,mBAAmB;IAC5C,sBAAsB,EAAE,YAAY;IACpC,kBAAkB,EAAE,YAAY;IAChC,eAAe,EAAE,QAAQ;IACzB,cAAc,EAAE,QAAQ;EAC1B;;EAEA;IACE,yBAAyB,EAAE,gBAAgB;EAC7C;;EAEA;IACE,yBAAyB,EAAE,qBAAqB;EAClD;;EAEA;IACE,gBAAgB,EAAE,kBAAkB;EACtC;;EAEA;IACE,wBAAwB,EAAE,cAAc;EAC1C;;EAEA;IACE,aAAa,EAAE,SAAS;IACxB,sBAAsB,EAAE,aAAa;IACrC,SAAS,EAAE,UAAU;IACrB,WAAW,EAAE,WAAW;EAC1B;;EAEA;IACE,qBAAqB,EAAE,SAAS;EAClC;;EAEA;IACE,kBAAkB,EAAE,SAAS;IAC7B,qBAAqB,EAAE,SAAS;IAChC,cAAc,EAAE,SAAS;IACzB,eAAe,EAAE,SAAS;EAC5B;AACF","sourcesContent":[".ProseMirror {\n  p {\n    line-height: 1.625; /* leading-relaxed */\n    margin-top: 0.75rem; /* my-3 */\n    margin-bottom: 0.75rem;\n  }\n\n  p:first-of-type {\n    margin-top: 0; /* first:mt-0 */\n  }\n\n  p:last-of-type {\n    margin-bottom: 0; /* last:mb-0 */\n  }\n\n  & > p {\n    margin-top: 1.5rem; /* my-6 */\n    margin-bottom: 1.5rem;\n  }\n\n  h1 {\n    font-size: 1.875rem; /* text-3xl */\n  }\n\n  h2 {\n    font-size: 1.5rem; /* text-2xl */\n  }\n\n  h3 {\n    font-size: 1.25rem; /* text-xl */\n  }\n\n  h4 {\n    font-size: 1.125rem; /* text-lg */\n  }\n\n  h5 {\n    font-size: 1rem; /* text-base */\n  }\n\n  h6 {\n    font-size: 0.875rem; /* text-sm */\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-weight: bold; /* font-bold */\n    margin-top: 0; /* first:mt-0 */\n    margin-bottom: 0; /* last:mb-0 */\n  }\n\n  h1,\n  h2,\n  h3 {\n    margin-top: 0.5rem; /* mt-12 */\n  }\n\n  h4,\n  h5,\n  h6 {\n    margin-top: 0.2rem; /* mt-8 */\n  }\n\n  a.link {\n    color: #3b82f6; /* text-blue-500 */\n    font-weight: 800; /* font-extrabold */\n  }\n\n  a.link:visited {\n    color: #60a5fa; /* dark:text-blue-400 */\n  }\n\n  mark {\n    background-color: #f87171; /* bg-red-500 */\n    border-radius: 0.125rem; /* rounded-sm */\n    text-decoration-skip: ink; /* decoration-clone */\n    color: inherit; /* text-inherit */\n    padding: 0.25rem 0; /* py-1 px-0 */\n  }\n\n  mark.dark {\n    background-color: #fb7185; /* dark:bg-red-400 */\n  }\n\n  & img {\n    height: auto; /* h-auto */\n    width: 100%; /* w-full */\n    max-width: 100%; /* max-w-full */\n  }\n\n  [data-type=\"horizontalRule\"] {\n    margin-top: 2rem; /* my-8 */\n    margin-bottom: 2rem;\n    padding-top: 1rem; /* py-4 */\n    padding-bottom: 1rem;\n    transition: all 0.1s ease-in-out; /* transition-all duration-100 ease-in-out */\n    cursor: pointer;\n  }\n\n  [data-type=\"horizontalRule\"].ProseMirror-selectednode {\n    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */\n  }\n\n  [data-type=\"horizontalRule\"].ProseMirror-selectednode hr {\n    border-top: 1px solid rgba(0, 0, 0, 0.3); /* border-t-black/30 */\n  }\n\n  [data-type=\"horizontalRule\"]:hover:not(.ProseMirror-selectednode) {\n    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */\n  }\n\n  hr {\n    border: 0;\n    border-top: 1px solid rgba(0, 0, 0, 0.2); /* border-t border-black/20 */\n    background-color: rgba(0, 0, 0, 0.8); /* bg-black/80 */\n  }\n\n  [data-type=\"emoji\"] {\n    display: inline-block;\n  }\n\n  [data-type=\"emoji\"] img {\n    width: 1em;\n    height: 1em;\n    object-fit: cover;\n    display: block;\n  }\n}\n\n.ProseMirror {\n  .tableWrapper {\n    margin-top: 3rem; /* my-12 */\n    margin-bottom: 3rem;\n  }\n\n  table {\n    border-collapse: collapse;\n    border: 1px solid rgba(0, 0, 0, 0.1); /* border-black/10 */\n    border-radius: 0.375rem; /* rounded */\n    box-sizing: border-box; /* box-border */\n    width: 100%; /* w-full */\n  }\n\n  td,\n  th {\n    border: 1px solid rgba(0, 0, 0, 0.1); /* border-black/10 */\n    min-width: 100px; /* min-w-[100px] */\n    padding: 0.5rem; /* p-2 */\n    position: relative;\n    text-align: left; /* text-left */\n    vertical-align: top; /* align-top */\n  }\n\n  td:first-of-type:not(a) {\n    margin-top: 0; /* mt-0 */\n  }\n\n  td p {\n    margin: 0; /* m-0 */\n  }\n\n  td p + p {\n    margin-top: 0.75rem; /* mt-3 */\n  }\n\n  th {\n    font-weight: bold; /* font-bold */\n  }\n\n  .column-resize-handle {\n    bottom: -2px; /* -bottom-[2px] */\n    display: flex;\n    pointer-events: none; /* pointer-events-none */\n    position: absolute;\n    right: -1px; /* -right-1 */\n    top: 0; /* top-0 */\n    width: 0.5rem; /* w-2 */\n  }\n\n  .column-resize-handle::before {\n    background-color: rgba(0, 0, 0, 0.2); /* bg-black/20 */\n    height: 100%; /* h-full */\n    width: 1px; /* w-[1px] */\n    margin-left: 0.5rem; /* ml-2 */\n    content: \"\";\n  }\n\n  .selectedCell {\n    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */\n    border-color: rgba(0, 0, 0, 0.2); /* border-black/20 */\n    border-style: double; /* border-double */\n  }\n\n  .grip-column,\n  .grip-row {\n    align-items: center; /* items-center */\n    background-color: rgba(0, 0, 0, 0.05); /* bg-black/5 */\n    cursor: pointer; /* cursor-pointer */\n    display: flex;\n    justify-content: center; /* justify-center */\n    position: absolute;\n    z-index: 10; /* z-10 */\n  }\n\n  .grip-column {\n    width: calc(100% + 1px); /* w-[calc(100%+1px)] */\n    border-left: 1px solid rgba(0, 0, 0, 0.2); /* border-l border-black/20 */\n    height: 0.75rem; /* h-3 */\n    left: 0; /* left-0 */\n    margin-left: -1px; /* -ml-[1px] */\n    top: -0.75rem; /* -top-3 */\n  }\n\n  .grip-column:hover,\n  .grip-column.selected {\n    &::before {\n      content: \"\";\n      width: 0.625rem; /* w-2.5 */\n    }\n  }\n\n  .grip-column:hover {\n    background-color: rgba(0, 0, 0, 0.1); /* bg-black/10 */\n  }\n\n  .grip-column:hover::before {\n    border-bottom: 2px solid rgba(0, 0, 0, 0.6); /* border-b-2 border-dotted border-black/60 */\n  }\n\n  .grip-column.first {\n    border-color: transparent; /* border-transparent */\n    border-radius: 0.125rem 0 0 0; /* rounded-tl-sm */\n  }\n\n  .grip-column.last {\n    border-radius: 0 0.125rem 0 0; /* rounded-tr-sm */\n  }\n\n  .grip-column.selected {\n    background-color: rgba(0, 0, 0, 0.3); /* bg-black/30 */\n    border-color: rgba(0, 0, 0, 0.3); /* border-black/30 */\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15); /* shadow-sm */\n  }\n\n  .grip-column.selected::before {\n    border-bottom: 2px solid dotted; /* border-b-2 border-dotted */\n  }\n\n  .grip-row {\n    height: calc(100% + 1px); /* h-[calc(100%+1px)] */\n    border-top: 1px solid rgba(0, 0, 0, 0.2); /* border-t border-black/20 */\n    left: -0.75rem; /* -left-3 */\n    width: 0.75rem; /* w-3 */\n    top: 0; /* top-0 */\n    margin-top: -1px; /* -mt-[1px] */\n  }\n\n  .grip-row:hover,\n  .grip-row.selected {\n    &::before {\n      height: 0.625rem; /* h-2.5 */\n      content: \"\";\n    }\n  }\n\n  .grip-row:hover {\n    background-color: rgba(0, 0, 0, 0.1); /* bg-black/10 */\n  }\n\n  .grip-row:hover::before {\n    border-left: 2px solid dotted rgba(0, 0, 0, 0.6); /* border-l-2 border-dotted border-black/60 */\n  }\n\n  .grip-row.first {\n    border-color: transparent; /* border-transparent */\n    border-radius: 0.125rem 0 0 0; /* rounded-tl-sm */\n  }\n\n  .grip-row.last {\n    border-radius: 0 0.125rem 0 0; /* rounded-bl-sm */\n  }\n\n  .grip-row.selected {\n    background-color: rgba(0, 0, 0, 0.3); /* bg-black/30 */\n    border-color: rgba(0, 0, 0, 0.3); /* border-black/30 */\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15); /* shadow-sm */\n  }\n\n  .grip-row.selected::before {\n    border-left: 2px solid dotted; /* border-l-2 border-dotted */\n  }\n}\n\n.ProseMirror ol {\n  list-style-type: decimal; /* list-decimal */\n}\n\n.ProseMirror ul {\n  list-style-type: disc; /* list-disc */\n}\n\n.ProseMirror ul,\n.ProseMirror ol {\n  padding-top: 0; /* py-0 */\n  padding-bottom: 0; /* py-0 */\n  padding-left: 2rem; /* px-8 */\n  padding-right: 2rem; /* px-8 */\n  margin-top: 1.5rem; /* my-6 */\n  margin-bottom: 1.5rem; /* my-6 */\n}\n\n.ProseMirror ul:first-child,\n.ProseMirror ol:first-child {\n  margin-top: 0; /* first:mt-0 */\n}\n\n.ProseMirror ul:last-child,\n.ProseMirror ol:last-child {\n  margin-bottom: 0; /* last:mb-0 */\n}\n\n.ProseMirror ul ul,\n.ProseMirror ul ol,\n.ProseMirror ul li,\n.ProseMirror ol ul,\n.ProseMirror ol ol,\n.ProseMirror ol li {\n  margin-top: 0.25rem; /* my-1 */\n  margin-bottom: 0.25rem; /* my-1 */\n}\n\n.ProseMirror ul p,\n.ProseMirror ol p {\n  margin-top: 0; /* mt-0 */\n  margin-bottom: 0.25rem; /* mb-1 */\n}\n\n.ProseMirror > ul,\n.ProseMirror > ol {\n  margin-top: 2rem; /* my-8 */\n  margin-bottom: 2rem; /* my-8 */\n}\n\n.ProseMirror > ul:first-child,\n.ProseMirror > ol:first-child {\n  margin-top: 0; /* first:mt-0 */\n}\n\n.ProseMirror > ul:last-child,\n.ProseMirror > ol:last-child {\n  margin-bottom: 0; /* last:mb-0 */\n}\n\n.ProseMirror ul[data-type=\"taskList\"] {\n  list-style-type: none; /* list-none */\n  padding: 0; /* p-0 */\n}\n\n.ProseMirror ul[data-type=\"taskList\"] p {\n  margin: 0; /* m-0 */\n}\n\n.ProseMirror ul[data-type=\"taskList\"] li {\n  display: flex; /* flex */\n}\n\n.ProseMirror ul[data-type=\"taskList\"] li > label {\n  flex-grow: 0; /* grow-0 */\n  flex-shrink: 0; /* shrink-0 */\n  flex-basis: auto; /* flex-auto */\n  margin-top: 0.25rem; /* mt-1 */\n  margin-right: 0.5rem; /* mr-2 */\n  user-select: none; /* select-none */\n}\n\n.ProseMirror ul[data-type=\"taskList\"] li > div {\n  flex-basis: auto; /* flex-auto */\n}\n\n.ProseMirror ul[data-type=\"taskList\"] li[data-checked=\"true\"] {\n  text-decoration: line-through; /* line-through */\n}\n\n.ProseMirror code {\n  caret-color: white; /* caret-white */\n  color: white; /* text-white */\n  background-color: #1a1a1a; /* bg-neutral-900 */\n  border-radius: 0.125rem; /* rounded-sm */\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* shadow-lg */\n  font-family: monospace; /* font-mono */\n}\n\n.ProseMirror code::selection {\n  background-color: rgba(255, 255, 255, 0.3); /* bg-white/30 */\n}\n\n.ProseMirror pre {\n  caret-color: white; /* caret-white */\n  background-color: #3f3f46; /* bg-neutral-700 */\n  color: white; /* text-white */\n  border-radius: 0.25rem; /* rounded */\n  margin-top: 3rem; /* my-12 */\n  margin-bottom: 3rem; /* my-12 */\n  padding: 1rem; /* p-4 */\n  border: 1px solid black; /* border-black */\n}\n\n.ProseMirror pre.dark {\n  background-color: #1a1a1a; /* dark:bg-neutral-900 */\n  border-color: #1f2937; /* dark:border-neutral-800 */\n}\n\n.ProseMirror pre *::selection {\n  background-color: rgba(255, 255, 255, 0.2); /* bg-white/20 */\n}\n\n.ProseMirror pre code {\n  background-color: inherit; /* bg-inherit */\n  color: inherit; /* text-inherit */\n  padding: 0; /* p-0 */\n  box-shadow: none; /* shadow-none */\n}\n\n.ProseMirror pre .hljs-comment,\n.ProseMirror pre .hljs-quote {\n  color: #9ca3af; /* text-neutral-400 */\n}\n\n.ProseMirror pre .hljs-variable,\n.ProseMirror pre .hljs-template-variable,\n.ProseMirror pre .hljs-attribute,\n.ProseMirror pre .hljs-tag,\n.ProseMirror pre .hljs-name,\n.ProseMirror pre .hljs-regexp,\n.ProseMirror pre .hljs-link,\n.ProseMirror pre .hljs-selector-id,\n.ProseMirror pre .hljs-selector-class {\n  color: #f87171; /* text-red-300 */\n}\n\n.ProseMirror pre .hljs-number,\n.ProseMirror pre .hljs-meta,\n.ProseMirror pre .hljs-built_in,\n.ProseMirror pre .hljs-builtin-name,\n.ProseMirror pre .hljs-literal,\n.ProseMirror pre .hljs-type,\n.ProseMirror pre .hljs-params {\n  color: #fb923c; /* text-orange-300 */\n}\n\n.ProseMirror pre .hljs-string,\n.ProseMirror pre .hljs-symbol,\n.ProseMirror pre .hljs-bullet {\n  color: #4ade80; /* text-lime-300 */\n}\n\n.ProseMirror pre .hljs-title,\n.ProseMirror pre .hljs-section {\n  color: #facc15; /* text-yellow-300 */\n}\n\n.ProseMirror pre .hljs-keyword,\n.ProseMirror pre .hljs-selector-tag {\n  color: #2dd4bf; /* text-teal-300 */\n}\n\n.ProseMirror pre .hljs-emphasis {\n  font-style: italic;\n}\n\n.ProseMirror pre .hljs-strong {\n  font-weight: 700; /* font-bold */\n}\n\n.ProseMirror {\n  /* Image Block */\n  figure[data-type=\"imageBlock\"] {\n    margin: 0;\n  }\n\n  figure[data-type=\"imageBlock\"] img {\n    border-radius: 0.25rem; /* Rounded */\n    display: block; /* Block */\n    width: 100%; /* W-full */\n  }\n\n  /* Block Quote */\n  figure[data-type=\"blockquoteFigure\"] {\n    margin-top: 3.5rem; /* my-14 */\n    margin-bottom: 3.5rem; /* my-14 */\n    color: #000000; /* Text-black */\n  }\n\n  figure[data-type=\"blockquoteFigure\"].dark {\n    color: #ffffff; /* Dark:text-white */\n  }\n\n  & > blockquote,\n  [data-type=\"blockquoteFigure\"] blockquote {\n    margin: 0; /* M-0 */\n  }\n\n  [data-type=\"blockquoteFigure\"] blockquote > *:first-child {\n    margin-top: 0; /* First:mt-0 */\n  }\n\n  [data-type=\"blockquoteFigure\"] blockquote > *:last-child {\n    margin-bottom: 0; /* Last:mb-0 */\n  }\n\n  /* Columns */\n  [data-type=\"columns\"] {\n    display: grid; /* Grid */\n    gap: 1rem; /* Gap-4 */\n    margin-top: 3.5rem; /* Mt-14 */\n    margin-bottom: 3rem; /* Mb-12 */\n  }\n\n  [data-type=\"columns\"].layout-sidebar-left {\n    grid-template-columns: 40fr 60fr;\n  }\n\n  [data-type=\"columns\"].layout-sidebar-right {\n    grid-template-columns: 60fr 40fr;\n  }\n\n  [data-type=\"columns\"].layout-two-column {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  [data-type=\"column\"] {\n    overflow: auto; /* Overflow-auto */\n  }\n\n  /* Details */\n  [data-type=\"details\"] {\n    display: flex; /* Flex */\n    gap: 0.25rem; /* Gap-1 */\n    margin-top: 1.5rem; /* My-6 */\n    margin-bottom: 1.5rem; /* My-6 */\n    margin-left: auto; /* Mx-auto */\n    margin-right: auto; /* Mx-auto */\n    padding: 0.5rem; /* P-2 */\n    border: 1px solid #d1d5db; /* Border-gray-300 */\n    border-radius: 0.25rem; /* Rounded */\n  }\n\n  [data-type=\"details\"] summary {\n    font-weight: bold; /* Font-bold */\n    display: block; /* Block */\n  }\n\n  [data-type=\"details\"] > button {\n    background-color: transparent; /* Bg-transparent */\n    border: none; /* Border-none */\n    cursor: pointer; /* Cursor-pointer */\n    display: flex; /* Flex */\n    align-items: center; /* Items-center */\n    justify-content: center; /* Justify-center */\n    border-radius: 0.25rem; /* Rounded */\n    font-size: 0.75rem; /* Text-xs */\n    height: 1.25rem; /* H-5 */\n    width: 1.25rem; /* W-5 */\n  }\n\n  [data-type=\"details\"] > button:hover {\n    background-color: #d1d5db; /* Bg-gray-300 */\n  }\n\n  [data-type=\"details\"].dark > button:hover {\n    background-color: #1f2937; /* Dark:bg-gray-800 */\n  }\n\n  [data-type=\"details\"] > button::before {\n    content: \"\\25B6\"; /* Triangle icon */\n  }\n\n  [data-type=\"details\"].is-open > button::before {\n    transform: rotate(90deg); /* Rotate-90 */\n  }\n\n  [data-type=\"details\"] > div {\n    display: flex; /* Flex */\n    flex-direction: column; /* Flex-col */\n    gap: 1rem; /* Gap-4 */\n    width: 100%; /* W-full */\n  }\n\n  [data-type=\"details\"] > div > [data-type=\"detailsContent\"] > :last-child {\n    margin-bottom: 0.5rem; /* Mb-2 */\n  }\n\n  [data-type=\"details\"] [data-type=\"details\"] {\n    margin-top: 0.5rem; /* My-2 */\n    margin-bottom: 0.5rem; /* My-2 */\n    margin-left: 0; /* Mx-0 */\n    margin-right: 0; /* Mx-0 */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
